module.exports = __webpack_public_path__ + "img/file-earmark.e9ee6f0d.svg";